// Shared constants for CDM Documents settings (split from CDMDocumentsSettings.jsx)
import {
  Clock, Loader2, Layers, Box, Database, CheckCircle, XCircle,
} from 'lucide-react';
import languagesData from '../../../data/languages.json';

// Language display helpers (Phase 6.5)
const _langMap = Object.fromEntries(languagesData.languages.map(l => [l.code, l]));
export function getLangDisplay(code) {
  if (!code || code === 'auto') return { flag: '\u2753', label: 'Unknown', code: null };
  const entry = _langMap[code];
  if (entry) return { flag: entry.flag, label: entry.name, code: entry.code };
  return { flag: '\ud83c\udf10', label: code.toUpperCase(), code };
}

// Status badge colors
export const STATUS_COLORS = {
  queued: 'bg-gray-500',
  processing: 'bg-blue-500',
  structured: 'bg-purple-500',
  chunked: 'bg-indigo-500',
  embedding: 'bg-cyan-500',
  embedded: 'bg-cyan-500',
  indexed: 'bg-green-500',
  failed: 'bg-red-500',
  version_replacing: 'bg-amber-500'
};

export const STATUS_ICONS = {
  queued: Clock,
  processing: Loader2,
  structured: Layers,
  chunked: Box,
  embedding: Database,
  embedded: Database,
  indexed: CheckCircle,
  failed: XCircle
};

// Document type badges
export const DOC_TYPE_COLORS = {
  pdf: 'bg-red-100 text-red-800',
  image: 'bg-green-100 text-green-800',
  text: 'bg-blue-100 text-blue-800',
  html: 'bg-orange-100 text-orange-800',
  json: 'bg-yellow-100 text-yellow-800',
  docx: 'bg-indigo-100 text-indigo-800',
  email: 'bg-purple-100 text-purple-800',
  article: 'bg-cyan-100 text-cyan-800',
  url: 'bg-teal-100 text-teal-800',
  video: 'bg-pink-100 text-pink-800',
  audio: 'bg-violet-100 text-violet-800',
};

// Node type badges
export const NODE_TYPE_COLORS = {
  heading: 'bg-blue-100 text-blue-800',
  paragraph: 'bg-gray-100 text-gray-800',
  table: 'bg-green-100 text-green-800',
  list: 'bg-yellow-100 text-yellow-800',
  figure_caption: 'bg-purple-100 text-purple-800',
  json_record: 'bg-orange-100 text-orange-800',
  email_header: 'bg-pink-100 text-pink-800',
  code_block: 'bg-indigo-100 text-indigo-800',
  summary: 'bg-cyan-100 text-cyan-800'
};

// Chunk type badges
export const CHUNK_TYPE_COLORS = {
  semantic_pack: 'bg-blue-100 text-blue-800',
  atomic_table: 'bg-green-100 text-green-800',
  atomic_figure: 'bg-purple-100 text-purple-800',
  summary: 'bg-cyan-100 text-cyan-800'
};

/* Capability badge colors */
export const MODALITY_BADGES = {
  file: { label: 'PDF', className: 'bg-red-100 text-red-700' },
  image: { label: 'IMG', className: 'bg-green-100 text-green-700' },
  video: { label: 'VID', className: 'bg-purple-100 text-purple-700' },
  audio: { label: 'AUD', className: 'bg-yellow-100 text-yellow-700' },
  web: { label: 'WEB', className: 'bg-blue-100 text-blue-700' },
};

export const FILTER_TABS = [
  { key: 'all', label: 'All' },
  { key: 'file', label: 'PDF' },
  { key: 'image', label: 'Image' },
  { key: 'video', label: 'Video' },
  { key: 'web', label: 'Web' },
];

// Shared formatting helpers
export const formatDate = (dateStr) => {
  if (!dateStr) return 'N/A';
  return new Date(dateStr).toLocaleString();
};

export const truncateText = (text, maxLen = 100) => {
  if (!text) return '';
  return text.length > maxLen ? text.substring(0, maxLen) + '...' : text;
};

// Supported upload extensions
export const SUPPORTED_EXTENSIONS = ['.pdf', '.docx', '.xlsx', '.pptx', '.csv', '.txt', '.html', '.json', '.png', '.jpg', '.jpeg', '.gif', '.webp', '.tiff', '.md', '.mp4', '.avi', '.mov', '.mp3', '.wav', '.ogg', '.flac', '.m4a', '.aac'];
